import * as types from '../constants';

const getAlerts = (apiServiceGetUrl, serviceGet) => ({
  type: types.GET_ALERTS,
  apiServiceGetUrl,
  Get: serviceGet
});

const getAlertsSuccess = alerts => ({
  type: types.GET_ALERTS_SUCCESS,
  payload: { alerts }
});

const getAlertsError = error => ({
  type: types.GET_ALERTS_ERROR,
  payload: { error }
});

const editAlert = alert => ({
  type: types.EDIT_ALERT,
  payload: { alert }
});

const editAlertSuccess = alert => ({
  type: types.EDIT_ALERT_SUCCESS,
  payload: { alert }
});

const editAlertError = error => ({
  type: types.EDIT_ALERT_ERROR,
  payload: { error }
});

const sendAlertSuccess = alert => ({
  type: types.SEND_ALERT_SUCCESS,
  payload: { alert }
});

const sendAlertError = error => ({
  type: types.SEND_ALERT_ERROR,
  payload: { error }
});

const alertRead = alert => {
  const newAlert = { ...alert, statusWeb: types.READ };

  return {
    type: types.EDIT_ALERT,
    payload: { newAlert }
  };
};

const alertDismiss = alert => {
  const newAlert = { ...alert, statusWeb: types.DELETE };

  return {
    type: types.EDIT_ALERT,
    payload: { newAlert }
  };
};

const addAlert = alert => ({
  type: types.ADD_ALERT,
  payload: { alert }
});

const sendPaymentRemainderAlert = alert => {
  const newAlert = { ...alert, alertCode: types.ALERT_CODE_PAYMENT_REMINDER };

  return {
    type: types.SEND_PAYMENT_REMINDER_ALERT,
    payload: { newAlert }
  };
};

const updateAlertSuccess = alert => ({
  type: types.UPDATE_ALERT_SUCCESS,
  payload: { alert }
});

const updateAlertError = error => ({
  type: types.UPDATE_ALERT_ERROR,
  payload: { error }
});

const toggleNotificationDrawer = () => ({
  type: types.TOGGLE_NOTIFICATIONS_DRAWER
});

const toggleNotificationsPreference = status => ({
  type: types.TOGGLE_NOTIFICATIONS_PREFRENCE,
  status
});

const updateAlert = (alert, apiPatchUrl, servicePatch, apiServiceGetUrl, serviceGet) => ({
  type: types.UPDATE_ALERT,
  payload: { alert },
  apiPatchUrl,
  Patch: servicePatch,
  apiServiceGetUrl,
  Get: serviceGet
});

const getNotificationPreferences = () => ({
  type: types.GET_NOTIFICATION_PREFERENCES
});

const updateEnableNotificationsToggle = (userPreferences, frequencies, isNotificationPreferenceEnabled) => ({
  type: types.UPDATE_ENABLE_NOTIFICATIONS_TOGGLE,
  userPreferences,
  frequencies,
  isNotificationPreferenceEnabled
});

const updateToggle = (userPreferences, frequencies, isNotificationPreferenceEnabled, toggleState, id) => ({
  type: types.UPDATE_TOGGLE_STATE,
  userPreferences,
  frequencies,
  isNotificationPreferenceEnabled,
  toggleState,
  id
});

const getWebNotifications = () => ({
  type: types.FETCH_WEB_NOTIFICATIONS
});

const handleLoader = () => ({ type: types.LOADER });

const notificationRead = (notificationId, callBack, isNotificationAlreadyRead) => ({
  type: types.NOTIFICATION_READ,
  payload: notificationId,
  callBack,
  isNotificationAlreadyRead
});

const notificationReadException = (notificationId, allNotifications) => ({
  type: types.NOTIFICATION_READ_EXCEPTION,
  payload: notificationId,
  notifications: allNotifications
});

const deleteNotification = (notificationId, isDeleteAll = false) => ({
  type: types.DELETE_NOTIFICATION,
  payload: notificationId,
  deleteAll: isDeleteAll
});

const deleteAllNotifications = (filteredNotifications, isDeleteAll = false) => ({
  type: types.DELETE_ALL_NOTIFICATIONS,
  payload: filteredNotifications,
  deleteAll: isDeleteAll
});

const notificationActions = {
  getAlerts,
  getAlertsSuccess,
  getAlertsError,
  editAlert,
  editAlertSuccess,
  editAlertError,
  alertRead,
  alertDismiss,
  addAlert,
  updateAlert,
  updateAlertSuccess,
  updateAlertError,
  sendPaymentRemainderAlert,
  sendAlertSuccess,
  sendAlertError,
  toggleNotificationDrawer,
  toggleNotificationsPreference,
  getNotificationPreferences,
  updateEnableNotificationsToggle,
  updateToggle,
  handleLoader,
  getWebNotifications,
  deleteNotification,
  deleteAllNotifications,
  notificationRead,
  notificationReadException
};

export default notificationActions;
